import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-no-search-results',
  templateUrl: './no-search-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoSearchResultsComponent {}
